const es = {
	"By using this chat, you agree to our terms and privacy policy.": "Al utilizar este chat, acepta nuestras condiciones y nuestra política de privacidad.",
	"Type a reply...": "Escribe una respuesta..."
};

export { es as default };
//# sourceMappingURL=es.DO4rYeoU.js.map
